import { setupAuthInterceptor } from "@/utils/setupAuthInterceptor";
import axios, { AxiosError } from "axios";
import type {
  AxiosInstance,
  AxiosResponse,
} from "axios";

const baseURL =
  import.meta.env.VITE_NEGOCIACIONES_GRUPOS_BACKEND_API_URL ||
  "http://localhost:4000/api";

const negociacionesGrupoApi: AxiosInstance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

setupAuthInterceptor(negociacionesGrupoApi);

negociacionesGrupoApi.interceptors.response.use(
  (response: AxiosResponse) => response,
  async (error: AxiosError) => {
    return Promise.reject(error.response || "Algo salió mal");
  }
);

export { negociacionesGrupoApi };
